import { FilesCallback } from 'components/UploadInput';
import { action } from 'typesafe-actions';
import { FileUploaded, OPENCLAIM_TYPES } from './types';

export const setDraftId = (id: string) =>
  action(OPENCLAIM_TYPES.SET_DRAFT_ID, id);

export const setErrorDraft = (error: any) =>
  action(OPENCLAIM_TYPES.SET_ERROR_DRAFT, error);

export const setSuccessDraft = (data: any) =>
  action(OPENCLAIM_TYPES.SET_SUCCESS_DRAFT, data);

export const recoverDraft = (id: string | null) =>
  action(OPENCLAIM_TYPES.RECOVER_DRAFT, id);

export const setCurrentStep = (step: number) =>
  action(OPENCLAIM_TYPES.SET_CURRENT_STEP, step);

export const setUnlockedSteps = (step: number) =>
  action(OPENCLAIM_TYPES.SET_UNLOCKED_STEPS, step);

export const getBankList = () => action(OPENCLAIM_TYPES.GET_BANKLIST_REQUEST);

export const setBankList = (data: any) =>
  action(OPENCLAIM_TYPES.SET_DATA_BANKLIST, data);

export const getUserData = (tokenFront: any) =>
  action(OPENCLAIM_TYPES.GET_USER_REQUEST, tokenFront);

export const getFranchiseByCode = (code: string, cp: number) =>
  action(OPENCLAIM_TYPES.GET_USER_FRANCHISE, code, cp);

export const setFranchiseByCode = (data: any) =>
  action(OPENCLAIM_TYPES.SET_USER_FRANCHISE, data);

export const setUserData = (data: any) =>
  action(OPENCLAIM_TYPES.SET_DATA_USER, data);

export const clearAllSteps = () => action(OPENCLAIM_TYPES.CLEAR_DATA_STEP);

export const setOpenClaimDataStep = (
  data: any,
  step: string,
  destiny: 'stay' | 'forward',
) => action(OPENCLAIM_TYPES.SET_DATA_STEP, { data, step, destiny });

export const setRecoverDraft = (data: any) =>
  action(OPENCLAIM_TYPES.SET_RECOVER_DRAFT, data);

export const setStepsArray = (array: number[]) =>
  action(OPENCLAIM_TYPES.SET_STEPS_ARRAY, array);

export const finishDraft = () => action(OPENCLAIM_TYPES.FINISH_DRAFT);

export const setStatus = (status: string) =>
  action(OPENCLAIM_TYPES.SET_STATUS, status);

export const setFinalId = (id: string) =>
  action(OPENCLAIM_TYPES.SET_FINAL_ID, id);

export const uploadFileAction = (
  files: FilesCallback[],
  id: string,
  response: any,
) => action(OPENCLAIM_TYPES.UPLOAD_DOCUMENT, { files, id, response });

export const deleteFileAction = (idFile: string, claimId: string) =>
  action(OPENCLAIM_TYPES.DELETE_DOCUMENT, { idFile, claimId });

export const setDeleteFileAction = (files: FileUploaded[]) =>
  action(OPENCLAIM_TYPES.SET_DELETE_DOCUMENT, files);

export const setUploadFileAction = (files: FileUploaded[]) =>
  action(OPENCLAIM_TYPES.SET_UPLOAD_DOCUMENT, files);
